import { CHANNELS } from "../shared/channels";
import { MinipiMotd } from "../shared/types";
import { call } from "./bridge";
import { byId } from "./dom";
import { localDate } from "./views/routine_item";
import { t } from "./i18n";

// home's message of the day and the tip line under the studio timer. the server picks the tip and the minipi,
// so an unreachable minipi site only means chi says the tip herself

let site = "https://minipi.zirk.eu";
let dayShown = "";

function who(motd: MinipiMotd): string {
  const pi = motd.minipi;
  if (!pi) return "chi";
  const number = /^[0-9a-z]{1,4}$/i.test(pi.id) ? t("minipi #{id}", { id: pi.id }) : t("a minipi");
  return pi.name && pi.name !== pi.id ? `${pi.name} · ${number}` : number;
}

function setPicture(img: HTMLImageElement, url: string): void {
  const frame = img.parentElement as HTMLElement;
  frame.hidden = !url;
  if (!url) return;
  img.onerror = () => (frame.hidden = true);
  img.src = url;
}

async function rollMotd(day?: string): Promise<void> {
  const button = byId<HTMLButtonElement>("today-motd-next");
  button.disabled = true;
  try {
    const motd = await call<MinipiMotd>(CHANNELS.minipiMotd, day);
    site = motd.site || site;
    byId("today-motd-from").textContent = motd.kind === "minipi" ? t("{who} says", { who: who(motd) }) : t("{who} · art tip", { who: who(motd) });
    byId("today-motd-text").textContent = motd.tip;
    byId("today-motd-no").textContent = motd.minipi?.id || "";
    setPicture(byId<HTMLImageElement>("today-motd-img"), motd.minipi?.image || "");
    byId("today-motd-site").hidden = !motd.minipi;
    byId("today-motd").hidden = false;
  } catch {
    // no tip today is fine, home works without it
  } finally {
    button.disabled = false;
  }
}

// the first look each day is the day's message, the button rolls a fresh one
export function showMotd(): void {
  const today = localDate();
  if (dayShown === today) return;
  dayShown = today;
  void rollMotd(today);
}

export async function showStudioTip(): Promise<void> {
  try {
    const motd = await call<MinipiMotd>(CHANNELS.minipiMotd);
    byId("studio-tip-from").textContent = who(motd);
    byId("studio-tip-text").textContent = motd.tip;
    setPicture(byId<HTMLImageElement>("studio-tip-img"), motd.minipi?.image || "");
    byId("studio-tip").hidden = false;
  } catch {
    byId("studio-tip").hidden = true;
  }
}

export function setupMinipiCard(): void {
  byId("today-motd-next").addEventListener("click", () => void rollMotd());
  byId("today-motd-site").addEventListener("click", () => void call(CHANNELS.openExternal, site));
  byId("studio-tip").addEventListener("click", () => void showStudioTip());
}
